import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class CommunicationTemplateService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('CommunicationTemplate');
	}
	list(custID: System.Guid): Observable<TooBig4Car.Logic.CommunicationTemplate[]> {
		return this.myBaseService.loadAll(this.url + '/List/' + (custID ?? this.myBaseService.configData.DefaultEmptyGuid).toString());
	}
	save(tempItem: TooBig4Car.Logic.CommunicationTemplate): Observable<TooBig4Car.Logic.CommunicationTemplate> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: number, custID: System.Guid): Observable<TooBig4Car.Logic.CommunicationTemplate> {
		return this.myBaseService.getWithParams(id, this.url + '/Edit', '?customerID=' + (custID || this.myBaseService.configData.DefaultEmptyGuid), false);
	}

	getTokens(id: number): Observable<TooBig4Car.Logic.TokenDataHolder[]> {
		return this.myBaseService.loadAll(this.url + '/AvailableTokens/' + (id ?? 0));
	}
}
